const obtenerDimensionesDetachedWindow = () => {
    var parametros = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no";
    var width = window.innerWidth * 0.8;
    var height = window.innerHeight * 0.8;
    parametros += ",width=" + width;
    parametros += ",height=" + height;
    var left = (window.innerWidth / 2) - (width / 2);
    var top = (screen.height - height) / 2;
    parametros += ",left=" + left;
    parametros += ",top=" + top;
    return parametros
};

export const abrirDetachedWindow = (enlace: string) => {
    let popup = window.open(enlace, 'campanas', obtenerDimensionesDetachedWindow());
    // evitar memory leaks
    popup?.addEventListener('pagehide', () => {
        if (!popup?.location?.host) return;
        // hacer el objeto disponible para ser garbage collected
        popup = null;
    });
};

export const updateUrlParameter = (uri: string, key: string, value: string | null) => {
    if(uri){
        // remueve la parte de hash antes de operar con la uri
        const i = uri.indexOf('#');
        const hash = i === -1 ? '' : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);
      
        const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
      
        if (value === null) {
          // remueve par key-value si se especifica null
          uri = uri.replace(new RegExp(`([?&]?)${key}=[^&]*`, 'i'), '');
          if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
          }
          // remueve primera ocurrencia de & por ? si no hay ninguna ? presente
          if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
        } else if (uri.match(re)) {
          uri = uri.replace(re, `$1${key}=${value}$2`);
        } else {
          uri = `${uri + separator + key}=${value}`;
        }
        return uri + hash;
    }
    return uri
};

